import {Factory} from './Factory'
import Menu from '../EditorComponents/SocialProofBubble/Menu'
export class SocialProofBubbleFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('social-proof-bubble'),
      slug: 'editor-social-proof-bubble',
      "assets": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "background": {
        "phone": "color",
        "tablet": "color",
        "desktop": "color"
      },
      "customClasses": [],
      "constantClasses": {
        "phone": [
          {property: 'Width', value: 'WIDTH_XL'},
          {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
        ],
        "tablet": [
          {property: 'Width', value: 'WIDTH_XL'},
          {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
        ],
        "desktop": [
          {property: 'Width', value: 'WIDTH_XL'},
          {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
        ]
      },
      "containerClasses":{
        "phone": [],
        "tablet": [],
        "desktop":[]
      },
      "name":"SocialProofBubble",
    }
  }

  properties() {
    return {
      content: [
        {key: 'message', component:'ContentText', text:'message', property:'message'},
        {key: 'show-as-offer', component:'ContentToggle', text:'show as offer', property:'showAsOffer'},
        {key: 'with-verified', component:'ContentToggle', text:'with verified  message', property:'withVerified'},
        {key: 'verifiedMessage', component:'ContentText', text:'verified Message', property:'verifiedMessage'},
        {key: 'filter', component:'SocialProofOrdersFilter'},
        {key: 'interval', component:'ContentText', text:'interval', property:'interval'},
        {key: 'with-image', component:'ContentToggle', text:'with image', property:'withImage'},
      ],
      styles: [
        {key: 'position', component: 'FixedPositionProperty', class: 'containerClasses'},
        {key: 'rounded', component: 'RoundedProperty'},
        {key: 'border', component: 'BorderProperty'},
        {key: 'shadow', component: 'ShadowProperty'},
        {key: 'padding', component: 'PaddingProperty'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}